import instance from '../../api';

export const letters = {
  async read({
    page = 1,
    perPage,
    startDate,
    endDate,
    companyId,
    driverId,
    creatorId,
  }: {
    page?: number | string;
    perPage?: number | string;
    startDate?: string;
    endDate?: string;
    companyId?: number | string;
    driverId?: number | string;
    creatorId?: number | string;
  }) {
    const params = new URLSearchParams();

    if (page) params.append('page', String(page));
    if (perPage) params.append('perPage', String(perPage));
    if (startDate) params.append('startDate', startDate);
    if (endDate) params.append('endDate', endDate);
    if (companyId) params.append('companyId', String(companyId));
    if (driverId) params.append('driverId', String(driverId));
    if (creatorId) params.append('creatorId', String(creatorId));

    const { data }: any = await instance(`/letters/list?${params.toString()}`);

    return {
      data: data,
      count: data?.count,
    };
  },
  async create(payload: {
    startDate: string;
    endDate: string;
    driverId: number | string;
    note?: string;
  }) {
    try {
      const { data }: any = await instance.post('/letters/create', payload);
      return data;
    } catch (error: any) {
      if (error.response && error.response.status) {
        console.error('Error:', error.response.data?.error?.message || error.message);
      }
      throw error;
    }
  },
};
